import { c as _c } from "react/compiler-runtime";
/* istanbul ignore file */

import type { ElementType } from 'react';
import { SxProps, Theme, styled } from '@classify/react-core-components/styles';
import { OverridableComponent, OverrideProps } from '@mui/types';
import { SystemProps } from '@mui/system';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
type TypeMap<AdditionalProps = {}, Component extends ElementType = 'img'> = {
  props: AdditionalProps & SystemProps<Theme> & {
    sx?: SxProps<Theme>;
    size: number;
  };
  defaultComponent: Component;
};
export type Props<Component extends ElementType = TypeMap['defaultComponent'],
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
AdditionalProps = {}> = OverrideProps<TypeMap<AdditionalProps, Component>, Component>;
const Root = styled('div')(({
  theme: {
    palette
  }
}) => ({
  border: `1px solid`,
  borderColor: palette.layout.surface.border,
  borderRadius: '50%',
  backgroundColor: palette.layout.surface.alternativeBackground,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& > *': {
    objectFit: 'contain',
    width: '100%',
    height: '100%'
  }
}));
type RoundIllustationType = OverridableComponent<TypeMap>;
const RoundIllustration: RoundIllustationType = t0 => {
  const $ = _c(16);
  let component;
  let otherProps;
  let size;
  let sx;
  let t1;
  if ($[0] !== t0) {
    ({
      component,
      sx,
      size,
      alt: t1,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = component;
    $[2] = otherProps;
    $[3] = size;
    $[4] = sx;
    $[5] = t1;
  } else {
    component = $[1];
    otherProps = $[2];
    size = $[3];
    sx = $[4];
    t1 = $[5];
  }
  const alt = t1 === undefined ? "" : t1;
  const Component = component || "img";
  let t2;
  if ($[6] !== size || $[7] !== sx) {
    t2 = {
      width: size,
      height: size,
      ...sx
    };
    $[6] = size;
    $[7] = sx;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== Component || $[10] !== alt || $[11] !== otherProps) {
    t3 = <Component alt={alt} {...otherProps} />;
    $[9] = Component;
    $[10] = alt;
    $[11] = otherProps;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <Root sx={t2}>{t3}</Root>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export default RoundIllustration;